import { ready } from '~/core'
import addEvents from '~/utils/addEvents'

ready('back-top', '.back-top', (button) => {
  const trigger = document.querySelector("#back-top-trigger") || document.querySelector("#mainContent");
  const header = document.querySelector('header');
  let ticking = false;

  window.addEventListener('scroll', onScroll);

  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(() => {
        const scrollTop = trigger ? (window.scrollY - trigger.offsetTop) : window.scrollY;
        button.classList.toggle('back-top--visible', scrollTop - header.offsetHeight > 400);
        ticking = false;
      });
    }
  }
})
